export const Version = {
	version: '1.46.0-dev.5.244',
};
